export const SNAP_VERSION = "^0.3.4";
export { MsqClient, } from "./client";
export { InternalSnapClient } from "./internal";
export { MsqIdentity } from "./identity";
export { MSQICRC35Client, LOGIN_ROUTE, PAY_ROUTE, ICRC1_ROUTE } from "./icrc35-client";
export { ICRC35Connection, openICRC35Window, ICRC35AsyncRequest } from "icrc-35";
// these env variables are inlined during build process
// see ../inline-env-vars.js
export const SNAP_SITE_ORIGIN = "https://msq.tech";
export const SNAP_ID = "npm:@fort-major/msq";
